
import React, { FC, useCallback, useContext, useLayoutEffect, useRef } from "react";
import DruidWebchatContext, { DruidWebchatContextType, WebChatHeaderOptions } from "../../WebChatContext";


import { useMergedOptions } from "../../selectors/useMergedOptions";

// import * as bsIcons from 'react-icons/bs';
// import * as faIcons from 'react-icons/fa';
import { useWebChatRefsContext } from "../../hooks/useWebChatRefsContext";
import InlineSVG from 'svg-inline-react';
import useDruidLocalize from "../../hooks/useDruidLocalize";

const defaultMinimizeIcon =  ({size}: {size: any}) => {
    return `<svg stroke="currentColor" fill="currentColor" width="${size || 'auto'}" height="${size|| 'auto'}" stroke-width="0" viewBox="0 0 352 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>`
};

export const DruidMinimizeSelector: FC = () => {
    const [, druidWebChatDispatch, ,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    const { headerRef } = useWebChatRefsContext();
    const druidLocalize = useDruidLocalize();

    const { UI: { v2_minimize_icon = "", headerFontSize } = {},
        styleOptions: { } = {}
    } = useMergedOptions();

    useLayoutEffect(() => {
        //  const svgItem = headerRef?.querySelector<SVGElement>(".druid__webchat__header-minimize > svg")
        //  svgItem?.setAttribute('width', `${headerFontSize}`);
        //  svgItem?.setAttribute('height', `${headerFontSize}`);

    }, [headerRef, headerFontSize]);

    // var MinimizeIcon;
    // if(typeof v2_minimize_icon === "string") {
    //    MinimizeIcon = bsIcons[v2_minimize_icon] || faIcons[v2_minimize_icon];
    // } else {
    //    MinimizeIcon = v2_minimize_icon;
    // }
    
    // !!!!! --- Stylings are defined in DruidHeader.tsx !!!!!!
    return (
        <button className="druid__webchat__header-button druid__webchat__header-minimize" title={druidLocalize("DRUID_CLOSE_BUTTON_ALT")}
            onClick={(e) => { e.stopPropagation(); druidWebChatDispatch({ type: 'CLOSE_WEBCHAT' }) }}>
            {/* {MinimizeIcon && <MinimizeIcon  size={headerFontSize}></MinimizeIcon>} */}
            { <InlineSVG src={typeof v2_minimize_icon === "function" ? v2_minimize_icon({size: headerFontSize}): (v2_minimize_icon || defaultMinimizeIcon({size: headerFontSize}))} raw={true} ></InlineSVG> }
            {/* this should be the way to go with custom svg's. provide them as function -> string . hardcode standard icons from react-icons. */}
        </button>)
}




